import { render, staticRenderFns } from "./noticeDetailList.vue?vue&type=template&id=018af836&scoped=true"
import script from "./noticeDetailList.vue?vue&type=script&lang=js"
export * from "./noticeDetailList.vue?vue&type=script&lang=js"
import style0 from "./noticeDetailList.vue?vue&type=style&index=0&id=018af836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018af836",
  null
  
)

export default component.exports